import {refreshToken} from "@containers/auth/api/api";
import {IS_SEPARATED, LOGIN_PATH, TRACK_PATH} from "@constants/config";
import {getCookie, setCookie} from "@helpers/cookie/cookie";
import {ITokens, ITokensData} from "@containers/auth/types/auth";

export const LIFE_TIME_TO_UPDATE_MULTIPLIER = 0.5;

export const getUnixTime = () => Math.round(+new Date() / 1000);
export const getTokenLeftTime = (token: string) => {
    if (!token) {
        return
    }
    const tokenInfo = token.split('.')[1];
    const tokenInfoDecoded = window.atob(tokenInfo);
    const {exp, iat} = JSON.parse(tokenInfoDecoded);

    return exp - getUnixTime();
}

export const isTokenExpired = (token: string) => {
    if (!token) {
        return true
    }

    try {
        const tokenInfo = token.split('.')[1];
        const tokenInfoDecoded = window.atob(tokenInfo);
        const {exp, iat} = JSON.parse(tokenInfoDecoded);

        const tokenLeftTime = exp - getUnixTime();

        const minLifeTimeForUpdate = (exp - iat) * LIFE_TIME_TO_UPDATE_MULTIPLIER;

        return tokenLeftTime < minLifeTimeForUpdate
    } catch (e) {
        return true
    }
};

export const logOut = () => {

    setCookie("token", '', {"max-age": -1});
    setCookie("refreshToken", '', {"max-age": -1});
    if (IS_SEPARATED) {
        window.location.reload();
    } else {
        if (window.location.href === '/iTrack/logout') {
            window.location.reload();
        } else {
            window.location.href = '/iTrack/logout';
        }

    }

}
// Only paths of this site: the parameter comes from the address bar.
export const getSafeReturnUrl = (value: string | null): string | null => {
    if (!value || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) {
        return null
    }
    return value
}

export const buildLoginUrl = (returnUrl?: string) => {
    return returnUrl ? `${LOGIN_PATH}?returnUrl=${encodeURIComponent(returnUrl)}` : LOGIN_PATH
}

// Embedded in track1 the sign in ends with a full page load: track1 builds its session from the
// cookies on that request and, at /iTrack, sends the user on to their start page.
export const leaveLoginPage = () => {
    const returnUrl = getSafeReturnUrl(new URLSearchParams(window.location.search).get('returnUrl'))
    window.location.assign(returnUrl ?? TRACK_PATH)
}

export const saveTokens = (tokens: ITokens) => {
    if (!tokens) {
        return
    }
    const {token, refreshToken} = tokens;
    setCookie('refreshToken', refreshToken)
    setCookie('token', token)

}


export const refreshTokenWidthSave = async (): Promise<ITokensData | undefined> => {

    const res = await refreshToken()
    if (!res) {
        return
    }
    saveTokens(res)
    return res;
}


export const checkToken = async (): Promise<false | ITokens> => {


    const token = getCookie('token');
    const refreshToken = getCookie('refreshToken');

    if (!refreshToken && !token) {
        return false
    }

    if (token) {
        const tokenExpire = isTokenExpired(token);
        if (!tokenExpire) {
            return {token, refreshToken};
        }
        if (tokenExpire && !refreshToken) {
            return false;
        }
        if (tokenExpire && refreshToken) {
            const refreshTokenExpire = isTokenExpired(refreshToken);
            if (refreshTokenExpire) {
                return false;
            }

            const res = await refreshTokenWidthSave();
            if (!res) {
                return false;
            }
            return res;
        }
        return
    }

    if (refreshToken) {
        return await refreshTokenWidthSave();
    }

    return false
}

export const getUserInfo = async (): Promise<ITokensData> => {
    return await refreshTokenWidthSave();
}
